import { formatPercent, isNotDefined } from '@enterprise/core';

/**
 * Formats the provided number into a percentage.
 * @param {number} value The number to format
 * @param {number} decimals The number of decimals to be displayed
 * @returns
 */
export const usePercentFormat = (value?: number, decimals?: number, fallback = '?'): string => {
  if (isNotDefined(value)) {
    return fallback;
  }

  return formatPercent(value, decimals);
};
